module.exports = __webpack_public_path__ + "img/blueprint-background.29bbf341.png";